export default "__VITE_ASSET__b2d2fbac__"